import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9" alt="Flowmart" title="Flowmart" src="/flowmart-icon.svg" />
        ) : (
          <>
            {/* Light mode — dark text on light sidebar */}
            <img
              className={classNames(small ? "h-5 w-auto" : "h-7 w-auto", "block dark:hidden")}
              alt="Flowmart"
              title="Flowmart"
              src="/flowmart-logo.svg"
            />
            {/* Dark mode — white text on dark sidebar */}
            <img
              className={classNames(small ? "h-5 w-auto" : "h-7 w-auto", "hidden dark:block")}
              alt="Flowmart"
              title="Flowmart"
              src="/flowmart-logo-white.svg"
            />
          </>
        )}
      </strong>
    </h3>
  );
}
